import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {EvkFormComponentBase} from "@evomatik/evk-common";


@Component({
    selector: 'app-motivo-form',
    templateUrl: './motivo-form.component.html',
    styleUrls: ['./motivo-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MotivoFormComponent extends EvkFormComponentBase<any> implements OnInit {

    constructor(public fb: FormBuilder) {
        super(fb);
    }

    public get formBuild() {
        return this.fb.group({
            motivo: ['', [Validators.required, Validators.minLength(1)]]
        });

    }

}
